import React from "react";
import { FomrmLoginInput } from "../../LoginUser/styled/LoginStyles";

/**
 * 28/10/2026 (Quân): "tài khoản chủ chuỗi sẽ không setup các thông tin như điểm lẻ nữa".
 *
 * Chủ chuỗi THUẦN (sau "Separate owner account": không toạ độ, không bán — `laStation()` = false)
 * là một TÀI KHOẢN gắn với bên ký, không phải địa điểm. Form Edit Station của điểm lẻ (địa chỉ,
 * giờ mở cửa, bảng giá, tài chính, đánh giá, hotline) không áp dụng — và ô giá còn chặn Save im lặng
 * (Public Rate tự điền theo Country Rates ≠ base + insurance trống). Ở đây chỉ còn tên, email đăng
 * nhập, ghi chú nội bộ; lưu bằng `PutChainAccountAdmin` (chỉ gửi đúng các field này).
 */
export default function TaiKhoanChuoiForm(props: {
	name: string;
	setName: (v: string) => void;
	email: string;
	setEmail: (v: string) => void;
	note: string;
	setNote: (v: string) => void;
	loi?: string;
}) {
	const section: React.CSSProperties = {
		background: "#F9FAFB",
		border: "1px solid #E5E7EB",
		borderRadius: 10,
		padding: "14px 16px",
		marginBottom: 16,
	};
	const label: React.CSSProperties = { fontWeight: 600, fontSize: 12, color: "#374151", marginBottom: 3 };
	return (
		<div data-testid="chain-account-form" style={section}>
			<div style={{ fontWeight: 700, fontSize: 14, marginBottom: 6, color: "#1F2937" }}>Chain owner account</div>
			<p style={{ margin: "0 0 12px", fontSize: 12.5, color: "#667085", lineHeight: 1.45 }}>
				This is the chain&apos;s owner account, not a location. Address, hours, prices, finance and hotline are set on
				each station of the chain.
			</p>
			<div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 10 }}>
				<div>
					<div style={label}>Chain account name</div>
					<FomrmLoginInput value={props.name} onChange={(e) => props.setName(e.target.value)} />
				</div>
				<div>
					<div style={label}>Sign-in email</div>
					<FomrmLoginInput
						placeholder="owner@example.com"
						value={props.email}
						autoComplete="off"
						onChange={(e) => props.setEmail(e.target.value)}
					/>
					<div style={{ fontSize: 11.5, color: "#667085", marginTop: 3 }}>
						Must be an email no station or team member uses.
					</div>
				</div>
			</div>
			<div style={label}>Internal note</div>
			<FomrmLoginInput placeholder="Internal note" value={props.note} onChange={(e) => props.setNote(e.target.value)} />
			{props.loi ? <p style={{ margin: "8px 0 0", color: "#B42318", fontSize: 12.5 }}>{props.loi}</p> : null}
		</div>
	);
}
